import reClick from './reClick'

const importDirective = Vue => {
    Vue.directive('preventReClick', reClick);
};

export default importDirective
